export default "__VITE_ASSET__d375f136__"